module.exports = __webpack_public_path__ + "img/Dong_Xu@2x.29c8e3b8.png";